// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2Gvlu","select":"Header_select__26drc","clinic":"Header_clinic__1kArz"};